var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "edit-picker-box"
    },
    [
      _c(
        "el-dialog",
        { attrs: { title: "", visible: true, "before-close": _vm.closeBox } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "200px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: {
                        filterable: "",
                        placeholder: "姓名",
                        disabled: _vm.id !== 0
                      },
                      model: {
                        value: _vm.form.admin_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "admin_id", $$v)
                        },
                        expression: "form.admin_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: "", label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.canAddMemberAdmin, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代号:" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%" },
                    attrs: { placeholder: "代号", disabled: _vm.id !== 0 },
                    model: {
                      value: _vm.form.code,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "买手组:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { placeholder: "绑定买手组", filterable: "" },
                      model: {
                        value: _vm.form.pg_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pg_id", $$v)
                        },
                        expression: "form.pg_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: "", label: "全部" } }),
                      _vm._v(" "),
                      _vm._l(_vm.selectPicker, function(item) {
                        return _c("el-option", {
                          key: item.k,
                          attrs: { value: item.k, label: item.label }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色:", prop: "role_type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { placeholder: "角色" },
                      on: { change: _vm.handleRoleTypeChange },
                      model: {
                        value: _vm.form.role_type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "role_type", $$v)
                        },
                        expression: "form.role_type"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "4", label: "头部买手" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "1", label: "普通买手" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "3", label: "兼职买手" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "5", label: "高级买助" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "2", label: "中级买助" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: "6", label: "初级买助" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "可绑定核心档口次数:" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%" },
                    attrs: { placeholder: "输入次数" },
                    model: {
                      value: _vm.form.month_hexin_bind_num,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "month_hexin_bind_num", $$v)
                      },
                      expression: "form.month_hexin_bind_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.role_type !== "4"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "开启商城主页：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": "1", "inactive-value": "0" },
                        model: {
                          value: _vm.form.open_shopping_homepage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "open_shopping_homepage", $$v)
                          },
                          expression: "form.open_shopping_homepage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.id === 0 && _vm.form.open_shopping_homepage === "1") ||
              _vm.form.role_type === "4" ||
              _vm.form.open_shopping_homepage === "1"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "昵称:", prop: "nickname" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "昵称" },
                            model: {
                              value: _vm.form.nickname,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "nickname", $$v)
                              },
                              expression: "form.nickname"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "头像:" } },
                        [
                          !_vm.form.avatar
                            ? _c(
                                "el-upload",
                                {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    action: _vm.action,
                                    "on-success": _vm.uploadSuccess,
                                    "show-file-list": false,
                                    "with-credentials": ""
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" }
                                    },
                                    [_vm._v("点击上传")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.avatar
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "max-width": "450px",
                                    height: "auto",
                                    position: "relative"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      "object-fit": "contain",
                                      width: "100%",
                                      border: "1px solid #ddd"
                                    },
                                    attrs: { src: _vm.form.avatar }
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-circle-close",
                                    staticStyle: {
                                      "font-size": "36px",
                                      position: "absolute",
                                      top: "16px",
                                      right: "16px",
                                      color: "#fff",
                                      "text-shadow": "#000 1px 0 10px",
                                      cursor: "pointer"
                                    },
                                    on: { click: _vm.handleIconClick }
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "标签:", prop: "member_tag" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "标签" },
                            model: {
                              value: _vm.form.member_tag,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "member_tag", $$v)
                              },
                              expression: "form.member_tag"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "买手介绍:", prop: "member_desc" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "买手介绍" },
                            model: {
                              value: _vm.form.member_desc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "member_desc", $$v)
                              },
                              expression: "form.member_desc"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商城主页擅长标签:",
                            prop: "shopping_homepage_tag"
                          }
                        },
                        [
                          _vm._l(_vm.form.shopping_homepage_tag, function(tag) {
                            return _c(
                              "el-tag",
                              {
                                key: tag,
                                staticStyle: { "margin-right": "5px" },
                                attrs: {
                                  closable: "",
                                  "disable-transitions": false
                                },
                                on: {
                                  close: function($event) {
                                    return _vm.handleClose(tag)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(tag))]
                            )
                          }),
                          _vm._v(" "),
                          _vm.inputVisible
                            ? _c("el-input", {
                                ref: "saveTagInput",
                                staticClass: "input-new-tag",
                                staticStyle: { width: "50%" },
                                attrs: {
                                  placeholder: "请输入擅长标签",
                                  maxlength: "8",
                                  "show-word-limit": "",
                                  size: "small"
                                },
                                on: { blur: _vm.handleInputConfirm },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleInputConfirm.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.inputValue,
                                  callback: function($$v) {
                                    _vm.inputValue = $$v
                                  },
                                  expression: "inputValue"
                                }
                              })
                            : _c(
                                "el-button",
                                {
                                  staticClass: "button-new-tag",
                                  attrs: { size: "small" },
                                  on: { click: _vm.showInput }
                                },
                                [_vm._v("+ 添加")]
                              )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "认证信息:" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            attrs: { placeholder: "认证信息", maxlength: "8" },
                            model: {
                              value: _vm.form.auth_information,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "auth_information", $$v)
                              },
                              expression: "form.auth_information"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "负责市场:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        multiple: "",
                        placeholder: "请选择市场"
                      },
                      model: {
                        value: _vm.form.market_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "market_id", $$v)
                        },
                        expression: "form.market_id"
                      }
                    },
                    _vm._l(_vm.markets, function(item) {
                      return _c("el-option", {
                        key: item.market_id,
                        attrs: {
                          value: item.market_id,
                          label: item.market_name
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "买手风格:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        multiple: "",
                        placeholder: "请选择风格"
                      },
                      model: {
                        value: _vm.form.style_id,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "style_id", $$v)
                        },
                        expression: "form.style_id"
                      }
                    },
                    _vm._l(_vm.styles, function(item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { value: item.key, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { placeholder: "状态" },
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: "", label: "全部" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: "1", label: "启用" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: "0", label: "禁用" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否参与新款初排:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { placeholder: "是否参与新款初排" },
                      model: {
                        value: _vm.form.new_style_arrange,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "new_style_arrange", $$v)
                        },
                        expression: "form.new_style_arrange"
                      }
                    },
                    [
                      _c("el-option", { attrs: { value: "1", label: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { value: "0", label: "否" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "25%" },
                      on: { click: _vm.closeBox }
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "25%" },
                      attrs: { type: "success" },
                      on: { click: _vm.submitData }
                    },
                    [_vm._v("\n          确认\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49479bc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49479bc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/picker/components/EditMember.vue
// module id = null
// module chunks = 